/**
 * Единый слой пользовательских текстов (ошибки, подсказки).
 * Добавляйте новые формулировки здесь; в компонентах — импорт и `apiErrorMessage` из `@/api/errors` при необходимости.
 */

/** Фракционирование (источник истины — re-export) */
export {
  FRACTIONATION_INPUT_ERROR,
  SETUP_PLAN_REQUIRED,
} from '@/composables/calculationConstants';

// --- Калькулятор TCP / NTCP ---
export const CALC_MODEL_PARAMS_FAILED =
  'Ошибка обработки параметров модели. Свяжитесь с администратором';

export const CALC_NTCP_MODEL_PARAMS_FAILED =
  'Ошибка обработки параметров NTCP модели. Свяжитесь с администратором';

export const CALC_PLOT_DISPLAY_FAILED =
  'Ошибка отображения графиков. Свяжитесь с администратором';

export const CALC_TCP_FAILED =
  'Ошибка расчета TCP. Свяжитесь с администратором';

export const CALC_TCP_INTERVALS_FAILED =
  'Ошибка расчета TCP с интервалами. Свяжитесь с администратором';

export const CALC_TCP_DISTRIBUTION_PLOT_FAILED =
  'Ошибка отображения графика распределения TCP.';

export const CALC_NTCP_FAILED =
  'Ошибка расчета NTCP. Свяжитесь с администратором';

export const CALC_NTCP_DISTRIBUTION_PLOT_FAILED =
  'Ошибка отображения графика распределения NTCP.';

export const CALC_LOAD_DATA_FAILED =
  'Ошибка загрузки данных. Свяжитесь с администратором';

export const CALC_SELECT_PLAN_FIRST = 'Сначала выберите план.';

export const CALC_SELECT_STRUCTURE_AND_MODEL = 'Сначала выберите структуру и модель.';

export const DVH_PLAN_MISSING =
  'Файл ГДО для этого плана больше не найден на сервере. Загрузите его снова.';

export const CALC_SELECT_PLAN_FAILED = 'Не удалось выбрать план.';

/**
 * @param {string} modelType — например TCP / NTCP
 */
export function calcPerformFailed(modelType) {
  return `Ошибка расчета ${modelType}. Свяжитесь с администратором`;
}

export const NTCP_HISTORY_RESTORE_FAILED =
  'Не удалось восстановить параметры NTCP из истории.';

// --- HTTP / API (дефолты до разбора тела ответа) ---
export const API_REQUEST_FAILED = 'Ошибка запроса';

export const API_NETWORK_UNAVAILABLE = 'Нет подключения к серверу';

export const API_TIMEOUT = 'Сервер не отвечает. Попробуйте ещё раз.';

// --- Авторизация и профиль ---
export const AUTH_INVALID_CREDENTIALS = 'Неверное имя пользователя или пароль.';

export const AUTH_FAILED = 'Ошибка авторизации. Обратитесь к администратору';

export const AUTH_SESSION_EXPIRED = 'Сессия истекла. Войдите снова.';

export const AUTH_SESSION_CHECK_FAILED =
  'Не удалось проверить сессию. Проверьте соединение и обновите страницу.';

export const AUTH_SIGNUP_FAILED =
  'Ошибка во время регистрации. Обратитесь к администрации.';

export const PROFILE_PASSWORD_CHANGE_FAILED = 'Ошибка при смене пароля.';

export const PROFILE_UPDATE_FAILED = 'Не удалось сохранить личные данные.';

export const ACCOUNT_PENDING_TITLE = 'Учётная запись ожидает подтверждения';

export const ACCOUNT_PENDING_BODY =
  'Администратор ещё не выдал доступ к расчётам. После подтверждения роли вы сможете пользоваться калькулятором.';

export const CALC_PERMISSION_DENIED =
  'Нет доступа к этому модулю расчёта. Обратитесь к администратору.';

export function calcQuotaExceeded(used, limit, period) {
  const usedLabel = used == null ? '—' : String(used);
  const limitLabel = limit == null ? 'без лимита' : String(limit);
  const periodLabel = period ? ` (период ${period})` : '';
  return `Исчерпана месячная квота расчётов: использовано ${usedLabel} из ${limitLabel}${periodLabel}.`;
}

export const ADMIN_CABINET_LOAD_FAILED = 'Не удалось загрузить кабинет администратора.';

export const ADMIN_SAVE_FAILED = 'Не удалось сохранить изменения.';

export const ADMIN_ERRORS_DELETE_FAILED = 'Не удалось удалить ошибки.';

export const ADMIN_ERRORS_EXPORT_FAILED = 'Не удалось выгрузить ошибки в CSV.';

export const ADMIN_ERRORS_EXPORT_EMPTY = 'По выбранному фильтру ошибок нет.';

export const ADMIN_ERRORS_EXPORT_TRUNCATED = (count, total) =>
  `Выгружено ${count} из ${total} ошибок. Уточните статус или период, чтобы не обрезать файл.`;

// --- Курсы ---
export const COURSE_LIST_LOAD_FAILED = 'Ошибка загрузки списка курсов.';

export const COURSE_CREATE_FAILED = 'Ошибка создания курса.';

export const COURSE_DELETE_FAILED = 'Не удалось удалить курс.';

export const COURSE_DELETE_CONFIRM_TITLE = 'Удалить курс?';

export const COURSE_DELETE_CONFIRM_BODY = (label) =>
  `Будут удалены курс «${label}» и все связанные расчёты из истории. Действие необратимо.`;

// --- Файлы (DVH) ---
export const FILE_SELECT_FAILED = 'Не удалось выбрать файл.';

export const FILE_DELETE_FAILED = 'Не удалось удалить файл.';

export const FILE_UPLOAD_FAILED = 'Ошибка при загрузке файла.';

export const FILE_FORMAT_TXT_ONLY = 'Выберите файл в формате .txt.';

export const FILE_PICK_REQUIRED = 'Пожалуйста, выберите файл для загрузки.';

export const STRUCTURE_REVIEW_LOAD_FAILED = 'Не удалось загрузить структуры из файла ГДО.';

export const STRUCTURE_REVIEW_SAVE_FAILED = 'Не удалось сохранить структуры ГДО.';

export const ADAPTIVE_RT_PLANS_MISSING =
  'Файлы ГДО этих этапов больше не найдены на сервере. Загрузите их заново.';

// --- История расчётов ---
export const HISTORY_LOAD_FAILED = 'Ошибка загрузки истории.';

export const HISTORY_OPEN_FAILED = 'Не удалось открыть запись.';

export const HISTORY_DELETE_FAILED = 'Не удалось удалить запись.';

export const HISTORY_DELETE_CONFIRM_TITLE = 'Удалить расчёт из истории?';

export const HISTORY_DELETE_CONFIRM_BODY =
  'Будут удалены все сохранённые записи этого сеанса (TCP, NTCP и др.). Действие необратимо.';

export const HISTORY_DELETE_RECORD_FAILED = 'Не удалось удалить запись расчёта.';

export const HISTORY_FORK_FAILED = 'Не удалось создать копию расчёта.';

export const HISTORY_OPEN_REQUIRES_RUN =
  'Запись без идентификатора сеанса не поддерживается. Удалите её из истории.';

export const HISTORY_EDIT_KEY_CHANGE_TITLE = 'Изменены структура или модель';

export const HISTORY_EDIT_KEY_CHANGE_BODY =
  'Вы изменили структуру или модель. Можно удалить прежнюю запись в этом сеансе или оставить обе.';

export const HISTORY_EDIT_KEY_CHANGE_SKIP_LABEL = 'Больше не показывать в этой сессии';

export const HISTORY_EDIT_DELETE_REPLACED_LABEL =
  'Удалить прежнюю запись (структура / модель) перед пересчётом';

export const HISTORY_EDIT_RUN_RECORDS_TITLE = 'Записи в этом сеансе';

// --- Отчёты ---
export const REPORT_SIGMOID_LOAD_FAILED =
  'Не удалось загрузить данные для сигмоидных кривых.';
